/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Cat_Urun_Stok_TitleInputs */

const tr_faq_cat_urun_stok_title = /** @type {(inputs: Faq_Cat_Urun_Stok_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ürün ve Stok Yönetimi`)
};

const en_faq_cat_urun_stok_title = /** @type {(inputs: Faq_Cat_Urun_Stok_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Products & Stock`)
};

const de_faq_cat_urun_stok_title = /** @type {(inputs: Faq_Cat_Urun_Stok_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkte und Bestand`)
};

const ru_faq_cat_urun_stok_title = /** @type {(inputs: Faq_Cat_Urun_Stok_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Товары и остатки`)
};

/**
* | output |
* | --- |
* | "Products & Stock" |
*
* @param {Faq_Cat_Urun_Stok_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_cat_urun_stok_title = /** @type {((inputs?: Faq_Cat_Urun_Stok_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Cat_Urun_Stok_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_cat_urun_stok_title(inputs)
	if (locale === "de") return de_faq_cat_urun_stok_title(inputs)
	if (locale === "ru") return ru_faq_cat_urun_stok_title(inputs)
	return tr_faq_cat_urun_stok_title(inputs)
});